import { z } from 'zod';

/**
 * Tính năng MỚI đang làm (anh Toàn chốt 30/10/2026): trang và API khoá bằng mật khẩu dùng thử, sidebar gắn dấu "Đang làm".
 *
 * Danh sách này là nguồn duy nhất: cổng ở máy chủ (`middleware/featurePreview.ts`), màn mở khoá và dấu ở sidebar đều đọc
 * từ đây, nên mục có mật khẩu luôn có dấu và ngược lại. Chỉ khai tính năng mới chưa nghiệm thu — KHÔNG khai lại các phân hệ
 * nhân viên đang dùng hằng ngày (cổng cũ khoá cả chúng nên đã bị gỡ 18/09/2026). Khách nghiệm thu thì xoá mục khỏi đây.
 *
 * `page`: tiền tố đường dẫn web (gồm trang con và ?query). `apis`: tiền tố API (không có `/api`).
 */
export const PREVIEW_FEATURES = {
 // YC-07 phần 1 (30/10/2026): danh mục vị trí kho và tồn theo vị trí.
 warehouseBins: { page: '/warehouse-locations', apis: ['/warehouse-bins'] },
} as const;
export type PreviewFeature = keyof typeof PREVIEW_FEATURES;
export const previewFeatureSchema = z.enum(Object.keys(PREVIEW_FEATURES) as [PreviewFeature, ...PreviewFeature[]]);
export const previewUnlockSchema = z.object({ password: z.string().min(1).max(200) });

export function previewFeatureFor(path: string, kind: 'page' | 'api'): PreviewFeature | undefined {
 const clean = path.split('?')[0]!.replace(/^\/api(?=\/)/, '');
 return (Object.keys(PREVIEW_FEATURES) as PreviewFeature[]).find(key => {
  const prefixes: readonly string[] = kind === 'page' ? [PREVIEW_FEATURES[key].page] : PREVIEW_FEATURES[key].apis;
  return prefixes.some(p => clean === p || clean.startsWith(p + '/'));
 });
}

export interface PreviewAccess { unlocked: boolean; configured: boolean; expiresAt: number | null }
